import * as React from 'react';

const Home = ()=> {

    return (  
        <div className="tableContainer">
            <div>Proarc extensions</div>
        </div> 
    );
}
export default Home


